import React, { useState } from 'react';
import { Pencil } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useSiteTranslation } from '../../hooks/useSiteTranslation';
import { resolveSectionContent, type LandingSection, type ResolvedSectionContent } from '../../i18n/localizeContent';
import SectionEditorDrawer from './SectionEditorDrawer';

interface EditableSectionProps {
  sectionKey: string;
  data: LandingSection | undefined;
  fallback: ResolvedSectionContent;
  onSaved: () => void;
  children: (content: ResolvedSectionContent) => React.ReactNode;
}

const EditableSection: React.FC<EditableSectionProps> = ({ sectionKey, data, fallback, onSaved, children }) => {
  const { isAdmin } = useAuth();
  const { i18n, siteName } = useSiteTranslation();
  const [editing, setEditing] = useState(false);

  const resolved = resolveSectionContent(data, i18n.language, fallback, siteName);

  return (
    <div className="relative group/cms">
      {children(resolved)}
      {isAdmin && (
        <button
          type="button"
          onClick={() => setEditing(true)}
          className="absolute top-2 right-2 opacity-0 group-hover/cms:opacity-100 focus:opacity-100 transition-opacity bg-white shadow-md rounded-full p-2 z-10 hover:bg-gray-50"
          title="Editar esta seção"
        >
          <Pencil className="w-4 h-4 text-primary-600" />
        </button>
      )}
      {editing && (
        <SectionEditorDrawer
          sectionKey={sectionKey}
          initialData={data}
          onClose={() => setEditing(false)}
          onSaved={() => {
            onSaved();
            setEditing(false);
          }}
        />
      )}
    </div>
  );
};

export default EditableSection;
